import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import PageTitle from '../common/page-title/index';
import InlineCKEditor from '../common/editor/inline-editor';
import AccountManagerPerformance from './account-manager-performance';
import { getStorePerformances } from '../../actions/store-performance';
import { loadPageContent } from '../../actions/content';
import { GROUP_ACCOUNT_MANAGER } from '../../data/userGroups';
import { getAccountManagerIncentivePerformances } from '../../actions/incentives';
import RetailerPerformance from './retailer-performance';

class StorePerformance extends Component {

  constructor(props) {
    super(props);

    this.pageSlug = 'store-performance';
  }

  componentDidMount() {
    const { dispatch, current_user } = this.props;
    if (current_user.attributes['user-group'] === GROUP_ACCOUNT_MANAGER) {
      dispatch(getAccountManagerIncentivePerformances());
    } else {
      dispatch(getStorePerformances());
    }
    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  isAccountManager = () => {
    const { attributes } = this.props.current_user;
    return attributes['user-group'] === 'account_manager';
  }

  isLoading() {
    if (this.isAccountManager()) {
      return this.props.incentivePerformancesLoading;
    }

    return this.props.loading;
  }

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  render() {
    return (
      <Grid bsClass="container">
        <Row>
          <Col lg={12}>
            <PageTitle>Sales Incentive</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <InlineCKEditor identifier={`${this.pageSlug}_content_text`}
                            onContentSaved={this.handleContentSaved}
                            contents={this.props.contents[`${this.pageSlug}_content_text`]}/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            {this.isLoading() && 'Loading...'}
            {!this.isLoading() && this.isAccountManager() && <AccountManagerPerformance />}
            {!this.isLoading() && !this.isAccountManager() && <RetailerPerformance />}
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.stores.fetching && !state.stores.fetched,
    contents: state.content.list,
    current_user: state.viewConfig.profile,
    incentivePerformancesLoading: !state.incentivePerformances.fetched,
  };
};

export default connect(mapStateToProps)(StorePerformance);



// WEBPACK FOOTER //
// ./src/components/store-performance/index.jsx